// extracted by mini-css-extract-plugin
export default {"container":"DevIcon_container__3O-zK","tooltip":"DevIcon_tooltip__6HSPT","icon":"DevIcon_icon__BrMXT"};